import React from 'react';
import { useNavigate } from 'react-router-dom';

const FaydaSuccess = () => {
  const navigate = useNavigate();
  const handleContinue = () => {
    navigate('/home');
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-8 text-center shadow-xl transition-all">
        
        {/* Success Icon Animation Wrapper */}
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-green-100 mb-6 animate-bounce">
          <svg
            className="h-10 w-10 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              d="M5 13l4 4L19 7"
            ></path>
          </svg>
        </div>

        {/* Title */}
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Verification Successful!
        </h2>

        {/* Description */}
        <p className="mt-4 text-sm text-gray-500 leading-relaxed">
          Your <span className="font-semibold text-gray-700">Fayda</span> digital identity verification has been successfully completed. Your account is now fully verified and secure.
        </p>

        {/* Divider */}
        <hr className="my-6 border-gray-200" />

        {/* Action Button */}
        <button
          onClick={handleContinue}
          className="inline-flex w-full justify-center rounded-xl bg-green-600 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 transition-all duration-200"
        >
          Continue to Dashboard
        </button>
        
      </div>
    </div>
  );
};

export default FaydaSuccess;